export const sevenDaysInMilliseconds = 604800000; // 7 days * 24 hours * 60 minutes * 60 seconds * 1000 milliseconds
export const TERMS_OF_SERVICE_CONSENT_ITEM = 'ct-terms-and-conditions-consent';

function getConsents() {
  try {
    const consentsString = localStorage.getItem(TERMS_OF_SERVICE_CONSENT_ITEM);
    if (consentsString === null) {
      return {};
    }

    return JSON.parse(consentsString) || {};
  } catch {
    return {};
  }
}

export function getLastConsentDate(customerId) {
  try {
    const consents = getConsents();
    return consents[customerId];
  } catch {
    return '';
  }
}

export function setLastConsentDate(customerId) {
  try {
    const consents = getConsents();
    consents[customerId] = new Date().getTime().toString();
    localStorage.setItem(TERMS_OF_SERVICE_CONSENT_ITEM, JSON.stringify(consents));
  } catch {
    /* eslint-disable no-console */
    console.warn('Local storage not available. User consent was not set.');
  }
}

function isOlderThanAWeekOrInvalid(lastTime) {
  const currentDate = new Date().getTime();
  const sevenDaysAgo = currentDate - sevenDaysInMilliseconds;
  const lastTimeAsNumber = Number(lastTime);
  if (isNaN(lastTimeAsNumber)) {
    return true;
  }

  return lastTimeAsNumber < sevenDaysAgo || currentDate < lastTimeAsNumber;
}

export function consentExpiredOrNotSet(customerId) {
  const lastConsentDate = getLastConsentDate(customerId);

  return lastConsentDate ? isOlderThanAWeekOrInvalid(lastConsentDate) : true;
}

export function isTermsAndConditionsObject(data) {
  return data?.['language'] !== undefined;
}
